import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconFlagOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], p = ["clip-path"], m = ["id"];
function _(e, t, r, g, h, i) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--flag-off"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Flag Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      fill: "currentColor"
    }, [...t[0] || (t[0] = [
      a("path", { d: "M3.5 1A.5.5 0 0 1 4 .5c.847 0 1.548.28 2.158.525l.028.01C6.82 1.29 7.36 1.5 8 1.5c.694 0 1.13-.115 1.377-.214a1.341 1.341 0 0 0 .28-.15.5.5 0 0 1 .843.364V7a.5.5 0 0 1-1 0V2.302c-.364.112-.854.198-1.5.198-.847 0-1.548-.28-2.158-.525l-.028-.01C5.18 1.71 4.64 1.5 4 1.5a.5.5 0 0 1-.5-.5ZM1.354.646a.5.5 0 1 0-.708.708l.854.853V11a.5.5 0 0 0 1 0V7.769c.035-.017.076-.036.123-.055C2.87 7.615 3.306 7.5 4 7.5c.64 0 1.18.21 1.814.464l.028.011c.558.224 1.193.477 1.945.52l2.86 2.859a.5.5 0 0 0 .707-.708l-10-10ZM4 6.5c.847 0 1.548.28 2.158.525l.028.01.237.095L2.5 3.207v3.491c.364-.112.854-.198 1.5-.198Z" }, null, -1)
    ])], 8, p),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, u);
}
const q = /* @__PURE__ */ c(f, [["render", _]]);
export {
  q as default
};
//# sourceMappingURL=flag-off.js.map
